import { BaseFetch } from "../main-model"
export default class ReportAssetEduModel extends BaseFetch {
    getReportAssetEduBy = (data) =>
    this.authFetch({
      url: "report-asset-edu/getReportAssetEduBy",
      method: "POST",
      body: JSON.stringify(data),
    })
}
